import { createGlobalStyle } from "styled-components";

export const SigninGlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;700;900&display=swap');

  :root {
    --font-size: 16px;
    
    /* Typography variables */
    --text-4xl: 48px;
    --text-3xl: 40px;
    --text-2xl: 24px;
    --text-xl: 18px;
    --text-base: 14px;
    --text-xs: 10px;
    --font-weight-light: 300;
    --font-weight-normal: 400;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --font-weight-black: 900;
    
    /* The default background color for the application. */
    --background: rgba(255, 255, 255, 1);
    /* The default color for elements or text that appears on top of the background. */
    --foreground: rgba(0, 0, 0, 1);
    /* The background color for cards, modals, and other containers. */
    --card: rgba(255, 255, 255, 1);
    /* The default color for text or elements that appear on top of cards, modals and other background containers. */
    --card-foreground: rgba(42, 42, 42, 1);
    /* The background color for dropdowns and tooltips. */
    --popover: rgba(255, 255, 255, 1);
    /* The default color for text or elements that appear on top of dropdowns and tooltips. */
    --popover-foreground: rgba(42, 42, 42, 1);
    /* The primary color used for buttons, links, and other interactive elements. */
    --primary: rgba(15, 98, 254, 1);
    /* The default color for text or elements that appear on top of primary colored elements. */
    --primary-foreground: rgba(255, 255, 255, 1);
    /* The secondary color used for secondary(but NOT-DESTRUCTIVE) buttons and interactive elements. */
    --secondary: rgba(0, 0, 0, 0);
    /* The default color for text or elements that appear on top of secondary colored elements. */
    --secondary-foreground: rgba(42, 42, 42, 1);
    /* The muted color used for less prominent elements, such as disabled buttons or disabled text. */
    --muted: rgba(250, 250, 250, 1);
    /* The default color for text or elements that appear on top of muted colored elements. */
    --muted-foreground: rgba(186, 186, 186, 1);
    /* The accent color used for highlights, links, and other interactive elements. */
    --accent: rgba(33, 115, 255, 1);
    /* The default color for text or elements that appear on top of accent colored elements. */
    --accent-foreground: rgba(255, 255, 255, 1);
    /* The color used for background in destructive actions, such as delete buttons or error messages. */
    --destructive: rgba(0, 0, 0, 0);
    /* The default color for text or elements that appear on top of destructive colored elements. */
    --destructive-foreground: rgba(153, 34, 34, 1);
    /* The default border color for elements such as inputs, buttons, and other containers. */
    --border: rgba(186, 186, 186, 1);
    /* The default background color for input fields once the text has been filled. Should be either transparent or match the input-background. */
    --input: rgba(0, 0, 0, 0);
    /* The default background color for input fields, text areas, and other input elements. */
    --input-background: rgba(250, 250, 250, 1);
    /* The color for focus rings, outlines, and other focus indicators. */
    --ring: rgba(33, 115, 255, 1);
    /* Shadow for small elevations, such as cards or modals. */
    --elevation-sm: 0px 21px 43.3px 0px rgba(0,0,0,0.04);
    /* The color for chart elements, such as a bar or line in a chart. */
    --chart-1: rgba(33, 115, 255, 1);
    /* The color for another chart element, such as a bar or line in a chart. */
    --chart-2: rgba(128, 175, 255, 1);
    /* The color for another chart element, such as a bar or line in a chart. */
    --chart-3: rgba(0, 160, 126, 1);
    /* The color for another chart element, such as a bar or line in a chart. */
    --chart-4: rgba(237, 108, 2, 1);
    /* The color for another chart element, such as a bar or line in a chart. */
    --chart-5: rgba(153, 34, 34, 1);
    /* The default border radius for elements such as buttons, tooltip, and other containers. */
    --radius: 8px;
    /* The background color for sidebars, navigation menus, and other persistent elements. */
    --sidebar: rgba(0, 0, 0, 0);
    /* The default color for text or elements that appear on top of sidebars, navigation menus, and other persistent elements. */
    --sidebar-foreground: rgba(255, 255, 255, 1);
    /* The primary color used for buttons, links, and other interactive elements in sidebars and navigation menus. */
    --sidebar-primary: rgba(33, 115, 255, 1);
    /* The default color for text or elements that appear on top of primary colored elements in sidebars and navigation menus. */
    --sidebar-primary-foreground: rgba(255, 255, 255, 1);
    /* The accent color used for highlights, links, and other interactive elements in sidebars and navigation menus. */
    --sidebar-accent: rgba(33, 115, 255, 1);
    /* The default color for text or elements that appear on top of accent colored elements in sidebars and navigation menus. */
    --sidebar-accent-foreground: rgba(255, 255, 255, 1);
    /* The default border color for elements in sidebars and navigation menus. */
    --sidebar-border: rgba(186, 186, 186, 1);
    /* The default color for focus rings, outlines, and other focus indicators in sidebars and navigation menus. */
    --sidebar-ring: rgba(33, 115, 255, 1);
    
    /* Brand colors */
    --brand-primary: #1B72FF;
    --brand-accent: #09E2AB;
    --brand-purple: #7B27ED;
    --brand-light-blue: #00B5D9;
    --brand-light: #FFFFFF;
    --brand-dark: #141414;
    --brand-gray: #434343;
    
    /* Background gradient using brand colors */
    --gradient-login: linear-gradient(135deg, #141414 0%, #1B72FF 50%, #00B5D9 100%);
  }

  html {
    font-size: var(--font-size);
  }

  body {
    font-family: 'Inter', sans-serif;
  }
`;
